import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    commissionShine: 'Shine commission',
    exchangeRate: 'Exchange rate',
    fee: 'Shine Commission',
    feeWithoutVat: '{0} VAT excl.',
    feeWithVat: '{0} VAT incl.',
    targetAmountLabel: 'Your recipient receives',
  },
  fr: {
    commissionShine: 'Commission Shine',
    exchangeRate: 'Taux de change',
    fee: 'Commission Shine',
    feeWithoutVat: '{0} HT',
    feeWithVat: '{0} TTC',
    targetAmountLabel: 'Votre bénéficiaire reçoit',
  },
} as const);

export default locales;
